import { useEffect } from 'react';
import { Button, Empty, Typography, Modal, Rate, Table } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { useSingleService } from './SingleServiceStore';

const { Text } = Typography;

function ServiceComments({ serviceId }) {
    const { comments, getComments, deleteComment } = useSingleService();

    useEffect(() => {
        if (serviceId) getComments(serviceId);
    }, [serviceId, getComments]);

    const handleDelete = (record) => {
        Modal.confirm({
            title: "Izohni o'chirishni tasdiqlang",
            okText: "O'chirish", okType: 'danger', cancelText: 'Bekor qilish',
            onOk: () => deleteComment(record.id, serviceId),
        });
    };

    const columns = [
        { title: 'ID', dataIndex: 'id', key: 'id', width: 60 },
        {
            title: 'Foydalanuvchi', dataIndex: 'user_fullname', key: 'user_fullname',
            render: (name, rec) => (
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    {rec.user_avatar ? <img src={process.env.REACT_APP_URL + rec.user_avatar} alt="" style={{ width: 28, height: 28, borderRadius: '50%', objectFit: 'cover' }} /> : null}
                    <span>{name || '—'}</span>
                </div>
            ),
        },
        {
            title: 'Baho', dataIndex: 'rating', key: 'rating', width: 160,
            render: (val) => <Rate disabled value={val} style={{ fontSize: 14 }} />,
        },
        { title: 'Izoh', dataIndex: 'comment', key: 'comment', ellipsis: true },
        { title: 'Sana', dataIndex: 'created', key: 'created', width: 160, render: (v) => v ? String(v).slice(0, 16) : '—' },
        {
            title: '', key: 'actions', width: 50,
            render: (_, rec) => (
                <Button type="text" danger size="small" icon={<DeleteOutlined />} onClick={() => handleDelete(rec)} />
            ),
        },
    ];

    return (
        <div style={{ padding: '16px 0' }}>
            <div style={{ marginBottom: 16 }}>
                <Text strong style={{ fontSize: 16 }}>Izohlar ({comments.length})</Text>
            </div>
            <Table
                dataSource={comments}
                columns={columns}
                rowKey="id"
                size="small"
                locale={{ emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Izohlar yo'q" /> }}
            />
        </div>
    );
}

export default ServiceComments;
